import { c as _c } from "react/compiler-runtime";
import { Button, ButtonProps } from "@/components/ui/button";
import { useState } from "react";
import clsx from "clsx";
export default function GradientButton(t0) {
  const $ = _c(17);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 50,
      y: 50
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [mousePosition, setMousePosition] = useState(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      const {
        left,
        top,
        width,
        height
      } = event.currentTarget.getBoundingClientRect();
      const x = (event.clientX - left) / width * 100;
      const y = (event.clientY - top) / height * 100;
      setMousePosition({
        x,
        y
      });
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleMouseMove = t2;
  let t3;
  if ($[5] !== className) {
    t3 = clsx("relative inline-flex", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const outerClassName = t3;
  let t4;
  if ($[7] !== mousePosition || $[8] !== props.disabled) {
    t4 = !props.disabled && <div className="absolute inset-0 rounded-md pointer-events-none transition-all duration-200" style={{
      background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(255, 0, 150, 0.3), rgba(0, 0, 255, 0.15))`,
      zIndex: 10,
      mixBlendMode: "lighten"
    }} />;
    $[7] = mousePosition;
    $[8] = props.disabled;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== className || $[11] !== props) {
    t5 = <Button {...props} className={className} data-sentry-element="Button" data-sentry-source-file="GradientButton.tsx" />;
    $[10] = className;
    $[11] = props;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== outerClassName || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={outerClassName} onMouseMove={handleMouseMove} data-sentry-component="GradientButton" data-sentry-source-file="GradientButton.tsx">{t4}{t5}</div>;
    $[13] = outerClassName;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}